const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_segments/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_segments/LIST_COMPANY_SEGMENTS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.company_segments/LIST_COMPANY_SEGMENTS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    default:
      return state;
  }
}
